import React, {Component} from 'react';
import { DragSource } from 'react-dnd';
import { Types } from '../../Services/Types';

export const ItemTypes = {
    CARD: 'card'
};

const knightSource = {
    beginDrag(props) {
        
      return {

        type: props.type,
        index: props.index
      };
    },
};

function collect(connect, monitor) {
    return {
      connectDragSource: connect.dragSource(),
      isDragging: monitor.isDragging(),
      connectDragPreview: connect.dragPreview()

    }
}

class Topdrag extends Component {
    constructor(props, context) {
		super(props, context);

        this.state = {
            style: {}
        }
    }

    render = () => {
        const {connectDragSource, value, type} = this.props;
        const img = new Image();
        switch(type)
        {
            case Types.ONE:
                
                img.src = '/preview_staket_markisvav_G2.svg';
                img.onload = () => {
                    this.props.connectDragPreview(img);
                }
            break;
            case Types.THREE:
                img.src = '/preview_staket_markisvav_G1.svg';
                img.onload = () => {
                    this.props.connectDragPreview(img);
                }
            break;
            case Types.TWO:
                img.src = '/preview_staket_forhjot_G2.svg';
                img.onload = () => {
                    this.props.connectDragPreview(img);
                }
            break;
            case Types.FOUR:
                img.src = '/preview_staket_forhjot_G1.svg';
                img.onload = () => {
                    this.props.connectDragPreview(img);
                }
            break;
            default:
            break;
        }

        return connectDragSource (
           
            <div className="innerseconddrag">
                <img src={value.image} />
                <h2 className="has-text-centered">{value.name}</h2>
                <ul className="has-text-centered">
                    <li>Bredd: {value.width} mm</li>
                    <li>Höjd: {value.height} mm</li>
                </ul>
            </div> 
                    
        )
    }
}

export default DragSource(ItemTypes.CARD, knightSource, collect)(Topdrag);


// WEBPACK FOOTER //
// ./src/Components/Topdrag/index.js